function parsePrice(price) {
  const parts = price.match(/(\d+)/g);

  return parts[1];
}

function addDiscount(discount) {
  const $price = document.getElementById("sw-price-total");
  const priceParsed = parseInt($price.textContent.replace("$", ""));

  return `$${(priceParsed - parseInt(discount)).toFixed(2)}`;
}

function selectYotpoSubscriptionItem(value) {
  let $radioSubscriptionLabel = document.querySelector(
    ".yotpo-radio-container.yotpo-radio-subscription-container label"
  );

  if (!$radioSubscriptionLabel) {
    $radioSubscriptionLabel = document.querySelector(
      ".yotpo-widget-subscriptions-add-to-cart label"
    );
  }

  if (!$radioSubscriptionLabel) return;

  const $swPTotal = document.getElementById("sw-price-sub-total");

  if (value == 1) {
    const radioSubscriptionLabels = document.querySelectorAll(
      ".yotpo-radio-container.yotpo-radio-subscription-container label"
    );

    if (radioSubscriptionLabels.length > 2) {
      const $lastLabel =
        radioSubscriptionLabels[radioSubscriptionLabels.length - 2];

      if ($lastLabel) {
        $radioSubscriptionLabel.click();
        $lastLabel.click();
        $swPTotal.textContent = `${addDiscount(parsePrice($lastLabel.textContent))} / bi-weekly`;
      }
    }
  }

  if (value == 2) {
    const radioSubscriptionLabels = document.querySelectorAll(
      ".yotpo-radio-container.yotpo-radio-subscription-container label"
    );

    if (radioSubscriptionLabels.length > 2) {
      const $lastLabel =
        radioSubscriptionLabels[radioSubscriptionLabels.length - 1];

      if ($lastLabel) {
        $radioSubscriptionLabel.click();
        $lastLabel.click();
        $swPTotal.textContent = `${addDiscount(parsePrice($lastLabel.textContent))} / monthly`;
      }
    }
  }
}

function checkYotpoSubscription() {
  let $yotpoContainer = document.querySelector(".yotpo-radio-container label");
  let yotpoExists = true;

  if (!$yotpoContainer) {
    $yotpoContainer = document.querySelector(
      ".yotpo-widget-subscriptions-add-to-cart label"
    );

    if (!$yotpoContainer) {
      const $swSubscription = document.getElementById("sw-subscription");
      const $swOneTime = document.getElementById("sw-one-time");

      yotpoExists = false;
      $swSubscription.remove();
      $swOneTime.classList.add("active");
      $swOneTime.classList.add("full-width");
      $swOneTime.classList.remove("sw-mb-2");
    }
  }

  if (yotpoExists) {
    const $yotpoOptions = document.querySelectorAll(
      ".yotpo-selling-plan-select-container .yotpo-select-wrapper .yotpo-frequency-options label.yotpo-frequency-option"
    );
    const yotpoOptions = new Set();

    $yotpoOptions.forEach(($yotpoOption) => {
      yotpoOptions.add($yotpoOption.textContent.trim());
    });

    const $selectSubscription = document.getElementById(
      "sw-select-subscription"
    );

    if ($selectSubscription) {
      Array.from(yotpoOptions).forEach((option, optionIndex) => {
        const $selectOption = document.createElement("option");

        $selectOption.value = (optionIndex + 1).toString();
        $selectOption.textContent = option;

        $selectSubscription.appendChild($selectOption);
      });
    }

    setTimeout(() => {
      document.getElementById("sw-select-subscription").value = "2";
      selectYotpoSubscriptionItem(2);
    }, 1000);
  }
}

function handleOnSelectSubscription() {
  const $selectSubscription = document.getElementById("sw-select-subscription");

  $selectSubscription.addEventListener("change", function (e) {
    const value = parseInt(e.target.value);

    selectYotpoSubscriptionItem(value);
  });
}

function handleOneTimeElements() {
  const $oneTimeElements = document.querySelectorAll(
    ".sw-price-product .one-time"
  );

  $oneTimeElements.forEach(($oneTimeElement) => {
    $oneTimeElement.addEventListener("click", (event) => {
      event.preventDefault();

      const $radioOneTime = document.querySelector(
        ".yotpo-radio-container.yotpo-radio-buy-once-container label"
      );

      if ($oneTimeElement.id === "sw-one-time") {
        if ($radioOneTime) {
          $radioOneTime.click();
        }
      }

      if (!$oneTimeElement.classList.contains("active")) {
        const $activeElement = document.querySelector(
          ".sw-price-product .one-time.active"
        );

        if ($activeElement) {
          $activeElement.classList.remove("active");
        }

        $oneTimeElement.classList.add("active");
      }
    });
  });
}

function handleAddToCartInput() {
  const $plusIcon = document.getElementById("plus-icon");
  const $minusIcon = document.getElementById("minus-icon");
  const $quantityInput = document.getElementById("quantity");

  $plusIcon.addEventListener("click", function () {
    let currentValue = parseInt($quantityInput.value);
    if (!isNaN(currentValue)) {
      $quantityInput.value = currentValue + 1;
    } else {
      $quantityInput.value = 1;
    }
  });

  $minusIcon.addEventListener("click", function () {
    let currentValue = parseInt($quantityInput.value);
    if (!isNaN(currentValue) && currentValue > 1) {
      $quantityInput.value = currentValue - 1;
    } else {
      $quantityInput.value = 1;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  handleAddToCartInput();
  handleOneTimeElements();
  handleOnSelectSubscription();

  setTimeout(() => {
    checkYotpoSubscription();
  }, 2000);
});
